import { v4 as uuidv4 } from 'uuid';

export const InitTagManager = (windowName: Window, gtmKey: string) => {
  (windowName as any).dataLayer = (window as any).dataLayer || [];
  (windowName as any).dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  (windowName as any).dataLayer.push({
    cookie_flags: 'SameSite=None;Secure',
    cookie_domain: 'auto',
  });

  const src = 'https://www.googletagmanager.com/gtm.js?id=' + gtmKey;
  const gtmScriptExists = scriptExists(src);
  if (!gtmScriptExists) {
    const firstScriptInPage = document.getElementsByTagName('script')[0];
    const newGTMScript = document.createElement('script');
    newGTMScript.async = true;
    newGTMScript.src = src;
    firstScriptInPage?.parentNode?.insertBefore(newGTMScript, firstScriptInPage);
  }
};

const scriptExists = (url: string) => {
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src === url) return true;
  }
  return false;
};

export const sendDataToDataLayer = (eventName: string, data: any, emmitDatalayer: boolean = false) => {
  if (emmitDatalayer) {
    window.parent.postMessage({ gaEventName: eventName, gaEventData: data }, '*');
  } else {
    const browserWindow = window as any;

    if (browserWindow.dataLayer) {
      browserWindow.dataLayer.push({
        event: eventName,
        ...data,
      });
    } else {
      console.error('GTM dataLayer not found');
    }
  }
};

export const getGAClientId = () => {
  let gaClientID = 'GA-';
  const gaCookie = document.cookie.split('; ').find((row) => row.startsWith('_ga='));
  if (gaCookie) {
    const gaCookieValue = gaCookie.split('=')[1];
    gaClientID += gaCookieValue.split('.').slice(2).join('.');
  } else {
    gaClientID += generateGAClientId();
  }
  return gaClientID;
};

/**
 * this function is called onlye when the user dont accept cookies
 * @returns generatedGAUserId
 */
const generateGAClientId = (): string => {
  if (!localStorage.getItem('unique_ga_client_id')) {
    localStorage.setItem('unique_ga_client_id', generateUniqueId());
  }
  return localStorage.getItem('unique_ga_client_id')!;
};

const generateUniqueId = () => {
  return uuidv4();
};
